import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/item/double/index.ts